import { render, staticRenderFns } from "./buildInfoAddOrUpdate.vue?vue&type=template&id=2f718c53&scoped=true&"
import script from "./buildInfoAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./buildInfoAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f718c53",
  null
  
)

export default component.exports